import styled from '@emotion/styled';
import { Stack } from '@mui/material';

export const CreateRequestContainer = styled(Stack)``;

export const RequestHeader = styled(Stack)`
  gap: 5px;
  margin-left: 5px;
  margin-right: 5px;
`;
